import React from "react"
import "../../assets/scss/styles.scss"
import question from "../../assets/img/question.svg"

export const Services = ({serviceFields}) => {


    return (
        <div className="active-fac-tab">
        <div className="tab-content-title">
            <h4 className="tab-content-title-text">
                Services
            </h4>
        </div>

        <ul className="contractor-info-list"> 
            { serviceFields?.map((s, i) => <li key={i}>{s}</li>) }
        </ul>
        </div>
    )
}